import Snackbar from "@mui/material/Snackbar"
import { styled } from "@mui/material/styles"
import AlertBox from "@mui/material/Alert"
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded"
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded"
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import PropTypes from "prop-types"

const StyledAlert = styled(AlertBox)(({ theme, severity }) => ({
    fontSize: "14px",
    fontWeight: "400",
    "& .MuiAlert-icon": {
        alignItems: "center",
        marginLeft: "auto",
        marginRight: "8px",
    },
    ...(severity === "success" && {
        backgroundColor: "#7fae1b",
        color: "rgba(0, 0, 0, 0.87)",
    }),
    ...(severity === "error" && {
        backgroundColor: "#c83e38",
        color: "#ffffff",
    }),
    ...(severity === "waiting" && {
        background: "#fec600",
        color: "#000000",
    }),
}))

const AlertNotification = (props) => {
    const { inputLabel, autoCloseTime, alertType, labelId, showHide, onClose } =
        props

    const handleClose = () => {
        onClose()
    }

    const handleIcon = (type) => {
        switch (type) {
            case "success":
                return <CheckCircleOutlineRoundedIcon />
            case "error":
                return <HighlightOffRoundedIcon />
            case "warning":
                return <ReportProblemOutlinedIcon />
            case "waiting":
                return <AccessTimeIcon />
            case "info":
                return <InfoOutlinedIcon />
            default:
                return <CheckCircleOutlineRoundedIcon />
        }
    }

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={showHide}
                autoHideDuration={autoCloseTime}
                onClose={handleClose}
            >
                <StyledAlert
                    onClose={handleClose}
                    severity={alertType}
                    id={labelId}
                    elevation={6}
                    variant="filled"
                    icon={handleIcon(alertType)}
                >
                    {inputLabel}
                </StyledAlert>
            </Snackbar>
        </div>
    )
}
AlertNotification.defaultProps = {
    alertType: "success",
    autoCloseTime: 6000,
    showHide: false,
    onClose: () => {},
}
AlertNotification.propTypes = {
    inputLabel: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    autoCloseTime: PropTypes.number,
    showHide: PropTypes.bool,
    alertType: PropTypes.oneOf([
        "success",
        "error",
        "warning",
        "waiting",
        "info",
    ]),
    onClose: PropTypes.func,
}
export default AlertNotification
